export default __webpack_public_path__ + "static/media/jake.d11e0e45.jpg";